<template>
  <div id="app">
    <router-view class="page-wrapper alt"/>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Центр мониторинга',
      link: [
        { rel: 'stylesheet', href: '/css/vendors.bundle.css' },
        { rel: 'stylesheet', href: '/css/app.bundle.css' },
        { rel: 'stylesheet', href: '/css/fa-brands.css' },
      ],
    }
  }
</script>